import { createRouter } from '@tanstack/react-router';
import { routeTree } from './routeTree.gen';
import {
  consumeBackNavigation,
  installBackNavigationDetection,
  isTopLevel,
} from './lib/route-transition';
import { isDesktopViewport } from './components/ui/use-mobile';

export const router = createRouter({
  routeTree,
  defaultPreload: 'intent',
  defaultViewTransition: {
    types: ({ pathChanged, fromLocation, toLocation }) => {
      if (!pathChanged) return false;
      // Desktop console: no page transition animations.
      if (isDesktopViewport()) return false;
      const isBack = consumeBackNavigation();
      if (
        fromLocation &&
        isTopLevel(fromLocation.pathname) &&
        isTopLevel(toLocation.pathname)
      ) {
        return ['tab-switch'];
      }
      return [isBack ? 'back' : 'forward'];
    },
  },
  context: {
    isAuthenticated: false,
    userIsAdmin: false,
  },
});

installBackNavigationDetection(router.history);

declare module '@tanstack/react-router' {
  interface Register {
    router: typeof router;
  }
}
